import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AttachmentService } from 'src/app/service/attachment.service';
import { FreeFormAgendaService } from 'src/app/service/free-form-agenda.service';
import { FreeFormMinutesService } from 'src/app/service/free-form-minutes.service';
import { AddLinkDialogComponent } from '../add-link-dialog/add-link-dialog.component';
import { MeetingService } from 'src/app/service/meeting.service';
import { AgendaTaskEditDialogComponent } from '../agenda-task-edit-dialog/agenda-task-edit-dialog.component';
import { AttachmentDialogComponent } from '../attachment-dialog/attachment-dialog.component';
import { Globals } from 'src/app/service/global';
import { environment, environment_const } from 'src/environments/environment';
import { UtilityService } from 'src/app/service/utility.service';
import { PermissionService } from 'src/app/service/permission.service';
import { HistoryComponent } from '../history/history.component';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { UtcDatePipe } from 'src/app/pipe/UtcDate.pipe';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { HistoryDialogService } from 'src/app/service/history-dialog.service';
import { LinkNotetotaskDialogComponent } from '../link-notetotask-dialog/link-notetotask-dialog.component';
import { CK5_EDITOR, buildCk5Config, CK5_READONLY_CONFIG, setupCk5UploadAdapter, CK5_TOOLBAR } from 'src/app/config/ck5-common';
import Quill from 'quill';
import { setupQuillUploadAdapter } from 'src/app/config/quill-common';
import { quillSharedToolbar } from 'src/app/config/quill-shared-toolbar';
import { AttendeeService } from 'src/app/service/attendee.service';

declare var CKEDITOR: any;

@Component({
  selector: 'app-instant-meeting-followup-task',
  templateUrl: './instant-meeting-followup-task.component.html',
  styleUrls: [
    './instant-meeting-followup-task.component.css',
    '../../../assets/adc-styles/ckeditor-agenda-custom.css'
  ],
  providers: [UtcDatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InstantMeetingFollowupTaskComponent implements OnInit,AfterViewInit {

    //UI Team variable declaration
    @Input() pinDialogTriggered = false;
    @Input()videoSectionStatusChecker : any
    @Input() contentEditableBoolmin : any=true;
    collabVariable = 'active'
    @Input()hideParts: any
  
    @Input()
    deviceXs!: boolean;
  
    @Input()
    deviceSm!: boolean;
  
    @Input()
    deviceMd! : boolean;
  
    @Input()
    deviceLg! : boolean;
  
    @Input()
    deviceXl! : boolean;
  
    //padlock variable
    padlock :any;
    matDialogRefs!: MatDialogRef<AttachmentDialogComponent>;
    matDialogRef!: MatDialogRef<AgendaTaskEditDialogComponent>;
    taskStatusList: any;
    taskStatusCode = new UntypedFormControl();
    isPrivate: any;
    showToolTip = false;
    taskCompleted :any ;
    agendaAttachResp: any;
    attachCount: boolean =true;
    attachmentCount: any;
    attachmentTotalCnt: any = true;
    attachmentIcon = 'Y';
    decryptKey: string = '';
    @Input() meetingResponse:any
    //@Output() isTaskAddedOrModified : any = new EventEmitter();
  disaleAttachmentFileIcon: any;
  taskInfo: any;
  toLinkingNotes: any;
  agendasinfoe: any;
  
  // CKEditor5 properties (legacy)
  public Editor: any = CK5_EDITOR;
  private activeEditor: any;
  public ck5Config: any;
  public ck5ReadOnlyConfig: any = {
    toolbar: [],
    table: { contentToolbar: [] }
  };
  private toolbarInteracting: boolean = false;
  private autosaveTimer: any = null;
  private lastSavedHtml: string = '';
  private blurSavingGuard = false;

  // Quill.js properties
  private quillInst?: Quill;
  private isActiveEditor: boolean = false;
  private hasUserInteracted: boolean = false;
  
  // @ Mention dropdown properties
  mentionList: any[] = [];
  showDropdown = false;
  activeIndex: number = 0;
  dropdownPosition = { top: 0, left: 0 };
  private mentionIndex: number = 0;
  public quillConfig: any = {
    enableTable : true,
    letter : false,
    modules: {
    toolbar: {
    container: [
    ['bold', 'italic', 'underline', 'strike'],    
    [{ list: 'ordered' }, { list: 'bullet' }],    
    [{ indent: '+1' }, { indent: '-1' }],        
    [{ color: [] }, { background: [] }],        
    ['image','link'],
    ],
    handlers: {
    insertheaderorfooter: () => {}, // just placeholder, real action via emitter
    subreport: () => {},
    preview: () => {},
    print: () => {},
    formula: () => {},
    },
    },
    },
    sharedToolbar : {enabled:true , selectorId:'quill-shared-toolbar'},
    placeholder: " ",
    theme: 'snow',
    };

    constructor(public freeFormAgenda:FreeFormAgendaService,private readonly breakpointObserver: BreakpointObserver,private utility:UtilityService,private permissionService:PermissionService,private globals: Globals, private dialog: MatDialog, public commonMinService: FreeFormMinutesService, private matDialog: MatDialog, public attachService: AttachmentService, public commonAgService: FreeFormAgendaService, private meetingService: MeetingService,private historyDialogService:HistoryDialogService,private utilService: UtilityService,private attendeeService: AttendeeService, private cdr: ChangeDetectorRef) {
      this.taskStatusList = this.globals.globaltaskStatusList;
    }

  private normalizeDueDateSpans(scope: HTMLElement) {
    try {
      // Remove BOM/ZWSP globally in scope
      const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
      const nodes: Text[] = [];
      while (walker.nextNode()) nodes.push(walker.currentNode as Text);
      nodes.forEach(t => { if (/[\uFEFF\u200B]/.test(t.data)) t.data = t.data.replace(/[\uFEFF\u200B]/g, ''); });

      const dates = Array.from(scope.querySelectorAll('span.minDateCls')) as HTMLSpanElement[];
      dates.forEach((el) => {
        try {
          el.removeAttribute('contenteditable');
          const inner = el.querySelector('span[contenteditable="false"]') as HTMLElement | null;
          if (inner) {
            while (inner.firstChild) el.insertBefore(inner.firstChild, inner);
            inner.remove();
          }
          if (!el.querySelector(':scope > span.dueLabelCls')) {
            const label = document.createElement('span');
            label.className = 'dueLabelCls';
            label.textContent = 'Due Date: ';
            el.insertBefore(label, el.firstChild);
          }
          if (!el.getAttribute('code')) {
            el.setAttribute('code', String(this.minAttrList?.followUpTaskInfo?.entityType || 'AI'));
          }
        } catch {}
      });
    } catch {}
  }
    @Input() minAttrList: any;
    taskDetails: any;

    isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
      Breakpoints.XSmall
      );
      isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
        Breakpoints.Medium
      )
      isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
        Breakpoints.Small
      )

    ngOnInit(): void {
     this.commonMinService.setActivateCkEditor(true);
     var padLockValue = this.minAttrList.isPrivate;
    
  
    // this.taskStatusCode.setValue(this.minAttrList.followUpTaskInfo.status)
      if(padLockValue == 'Y'){
        this.padlock = true;
      }else{
        this.padlock = false;
      }
      
      // Build CK5 config with @ mention feed
      try {
        this.ck5Config = buildCk5Config(this.meetingResponse);
        this.ck5Config.mention = {
          feeds: [
            {
              marker: '@',
              minimumCharacters: 0,
  
              feed: (queryText: any) => {
                const editableEl2 = this.activeEditor.ui.view.editable.element as HTMLElement;
                return this.getMentionUsers(editableEl2)
                  .then(users => {
                    if (!queryText) {
                      return users;
                    }
                    return users.filter((u: any) =>
                      u.name.toLowerCase().includes(queryText.toLowerCase())
                    );
                  });
              },
  
              itemRenderer: (item: any) => {
                const container = document.createElement('div');
                container.className = 'mention-item';
  
                const nameEl = document.createElement('div');
                nameEl.className = 'mention-item__name';
                nameEl.textContent = item.name;
  
                const emailEl = document.createElement('div');
                emailEl.className = 'mention-item__email';
                emailEl.textContent = item.email || '';
  
                container.appendChild(nameEl);
                container.appendChild(emailEl);
  
                return container;
              }
            }
          ]
        }
      } catch {
        this.ck5Config = { toolbar: CK5_TOOLBAR, table: { contentToolbar: ['tableColumn','tableRow','mergeTableCells'] } };
      }
      
      this.setCurrentStatusCodeByStatus();

      
    }
    ngAfterViewInit() {
     this.commonMinService.activateAllCkeditor('agChildTask');
     this.setCurrentStatusCodeByStatus();

    }
    
  // CKEditor 5: move toolbar to shared container
  private moveToolbarToShared(editor: any) {
    try {
      const toolbarEl = editor.ui.view.toolbar.element;
      const shared = document.querySelector('#ckEditBar');
      if (shared && toolbarEl && toolbarEl.parentElement !== shared) {
        (shared as HTMLElement).innerHTML = '';
        (shared as HTMLElement).appendChild(toolbarEl);
        (shared as HTMLElement).style.display = 'block';
      }
    } catch {}
  }
    handleMouseUp(noteElement: HTMLDivElement): void {
      const selection = window.getSelection();
      if (selection && selection.toString()) {
        noteElement.setAttribute('highlightIndex', '0');
      }
    }
  handleFocus(event: FocusEvent, noteElement: HTMLDivElement): void {
    noteElement.setAttribute('highlightIndex', '0'); 
  }
  
  handleKeyDown(event: KeyboardEvent, noteElement: HTMLDivElement): void {
    this.commonAgService.trackChangesWhileEditing(
      noteElement.getAttribute('taskId')!,
      noteElement.getAttribute('agId')!,
      event,
      noteElement.getAttribute('entityType')!,
      'agMinId' + noteElement.getAttribute('taskId')
    );
        if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'h') {
        event.preventDefault();
      this.highlightNextText(noteElement);
    }
  }
  
  highlightNextText(noteElement: HTMLDivElement): void {
    // const regex = /\[XXXXXX\]/gi;
    const regex = environment_const.patternKey;
    const content = noteElement.textContent || '';
    const matches = Array.from(content.matchAll(regex));
    const count = matches.length;
    if (count === 0) return;
  
    let currentIndex = parseInt(noteElement.getAttribute('highlightIndex') || '0', 10);
    noteElement.setAttribute('highlightIndex', ((currentIndex + 1) % count).toString());
  
    this.applyHighlight(noteElement, matches, currentIndex);
  }
  
  applyHighlight(noteElement: HTMLDivElement, matches: RegExpMatchArray[], highlightIndex: number): void {
    if (!noteElement.firstChild) return;
  
    const selection = window.getSelection();
    const range = document.createRange();
    
    const match = matches[highlightIndex];
    if (!match) return;
    const start = match.index!;
    const end = start + match[0].length;
  
  
    let offset = 0;
    let found = false;
    const nodes = Array.from(noteElement.childNodes);
    for (const node of nodes) {
      const nodeLength = node.textContent?.length || 0;
  
      if (offset + nodeLength >= start && !found) {
        const relativeStart = start - offset;
        const relativeEnd = end - offset;
        
        range.setStart(node, relativeStart);
        range.setEnd(node, Math.min(relativeEnd, nodeLength));
  
        found = true;
        break;
      }
  
      offset += nodeLength;
    }
  
    if (found) {
      selection?.removeAllRanges();
      selection?.addRange(range);
    }
  }
    getTooltipValue(): string {
      const selectedStatus = this.taskStatusList.find((data: { code: any; }) => data.code === this.taskStatusCode.value);
      return selectedStatus ? selectedStatus.description : 'Task';
    }
    ngOnChanges(event : any){
      this.setCurrentStatusCodeByStatus();
    }
    createEmptyAgenda(event:any){
      
      var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.AGENDA,this.utility.permissionType.ADD);
      
      if(!roleFlag){
        return
      }
      var newAg='AG'
      this.commonAgService.trackAgendaEventOnClick(event,newAg);
  
    }
    createEmptyNote(event:any){
      
      var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.NOTES,this.utility.permissionType.ADD);
      
      if(!roleFlag){
        return
      }
      var entityType="/nn";
      this.commonAgService.trackAgendaEventOnClick(event,entityType);
  
    }
    createEmptyTask(event:any){
      
      var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.TASK,this.utility.permissionType.ADD);
      
      if(!roleFlag){
        return
      }
      var entityType="/tt";
      this.commonAgService.trackAgendaEventOnClick(event,entityType);
  
    }
    createEmptyDecision(event:any){
      
      var roleFlag = this.permissionService.checkRoleRightsWithAlert(this.utility.featureList.NOTES,this.utility.permissionType.ADD);
      
      if(!roleFlag){
        return
      }
      var entityType="/dd";
      this.commonAgService.trackAgendaEventOnClick(event,entityType);
  
    }
    getMinComStatusCode(){

      if(this.meetingResponse.commonMomStatusCode == 'A'){
        this.disaleAttachmentFileIcon = false;
      }
    }

    
    ngOnDestroy(){
      // for (var instance in CKEDITOR.instances) {
      //   CKEDITOR.instances[instance].destroy();
      // }
    }

    setCurrentStatusCodeByStatus(){
      var statusCode = "";
      this.taskStatusList.forEach((data : any) => {
        if(data.codeId == this.minAttrList.followUpTaskInfo.status){
          statusCode = data.code
        }
      });
      
      this.taskStatusCode.setValue(statusCode)
    }
  
    statusTracker(id : any, vari : any){
      if(vari == 'active'){
        let element = (<HTMLElement>document.getElementById("agMinId"+id))
        element.contentEditable = 'false'
      }
      else if(vari == 'inActive'){
        let element = (<HTMLElement>document.getElementById("agMinId"+id))
        element.contentEditable = 'true'
      }
    }
  
    // used to open task edit dialog box
    taskEditDialog(curTaskUiInfo:any) {
      //
      var taskId = curTaskUiInfo.taskId;
      if(curTaskUiInfo.isFollowUpFlag=='Y'){
        taskId=curTaskUiInfo.prevMinuteId;
      }
      this.meetingService.fetchTaskInfo(taskId).subscribe(
        (meetingRes: any) => {
          this.taskDetails = meetingRes.body
         this.matDialogRef = this.matDialog.open(AgendaTaskEditDialogComponent, { data: {taskData :  meetingRes.body,curTaskUiInfo:curTaskUiInfo}, panelClass: ['animate__animated','animate__slideInLeft'],
          disableClose: true,
          position : {
            left : "0%"
          },
         
          maxHeight: "100vh",
          width: "50%",
          height : "100vh" });
          this.matDialogRef.afterClosed().subscribe(respValue => {
            this.commonAgService.curStatus$.subscribe(resp => {
              if(this.minAttrList.prevMinuteId == resp.minutesId){
               this.minAttrList.followUpTaskInfo.status = resp.status;
               this.setCurrentStatusCodeByStatus();
              }
             });
            // //
            // respValue = this.minAttrList
          });
        });
      }

 //attachment dialog

 openConfidentialDialog(e : any, m : any) {
    
  this.dialog.open(AttachmentDialogComponent,{
  data:{e,m, "data" : this.contentEditableBoolmin,"disaleAttachmentFileIcon":this.disaleAttachmentFileIcon},
   panelClass: ['animate__animated','animate__slideInLeft'],
               disableClose: true,
               position : {
                 left : "0%"
               },
              
               maxHeight: "100vh",
               width: "50%",
               height : "100vh"
 }).afterClosed().subscribe((response: any) => {
   this.meetingService.fetchTaskInfo(e.followUpTaskInfo._id).subscribe((data: any) => {
     
     if (data != undefined) {
       var minAttrList = this.minAttrList;
       if (minAttrList != null) {
        this.minAttrList.attachmentTotalCnt = data.body.attachmentTotalCnt
        this.commonAgService.pushAttachmentCount(this.minAttrList, data.body.attachmentTotalCnt,environment.noteEntityType);
       }
      }
   });
 });
 //
}

trackChanges(id : any){
  this.showToolTip = true;
  //
  let elementCreation = document.getElementById('agMinId'+id);
  $('#agMinId'+id).css("border","5px solid rgba(0,0,0,.12)")
}

removeTrackChanges(id : any){
  $('#agMinId'+id).css("border","0px")
  this.showToolTip = false
  //this.isTaskAddedOrModified.emit(this.minAttrList);
}

//used to update common task status
overAllTaskStatusUpdate(e: any) {
  var statusCode : any
    this.taskStatusList.forEach((data : any) => {
      if(data.code == this.taskStatusCode.value){
        statusCode = data.codeId
        e.status = statusCode; 
      }
    })
  this.commonMinService.updateOverAllTaskStatus(e,this.minAttrList,statusCode);

}

  //agenda link dialog

  addNewLink(entityId:any, meetingId:any) {
    this.dialog.open(AddLinkDialogComponent, {
      data:{entityId,meetingId,"entityType":"AI","attachmentMode":"LI","data" : this.contentEditableBoolmin,"disaleAttachmentFileIcon":this.disaleAttachmentFileIcon},
      panelClass: ['animate__animated','animate__slideInLeft'],
                  disableClose: true,
                  position : {
                    left : "0%"
                  },
                 
                  maxHeight: "100vh",
                  width: "50%",
                  height : "100vh"
    }).afterClosed().subscribe((response: any) => {
      this.meetingService.fetchTaskInfo(entityId).subscribe((data: any) => {
        
        if (data != undefined) {
          var minAttrList = this.minAttrList;
          if (minAttrList != null) {
           this.minAttrList.attachmentTotalCnt = data.body.attachmentTotalCnt
           this.commonAgService.pushAttachmentCount(this.minAttrList, data.body.attachmentTotalCnt,'AI');
          }
         }
      });
    });
  }
  getAttachCount(e:any){
    
     this.meetingService.fetchTaskInfo(e.followUpTaskInfo.taskId).subscribe((data: any) => { 
      this.agendaAttachResp = data.body;
      
      this.attachCount = false;
   });  
  }
  history(entityId:any,modifiedName:any) {
    var entityType ='AI';
    this.historyDialogService.openHistoryDialog(entityId,entityType, modifiedName, this.isMedium, this.isSmall, this.isExtraSmall);
  } 
 openLinkToNoteDialog(meetingId?: number): void {
     const id =  this.minAttrList.followUpTaskInfo.meetingId;
     const decryptKey = this.minAttrList?.decryptKey;
 
  
     if (!id || !this.minAttrList?.followUpTaskInfo.taskId) {
       console.error('Meeting ID or Task ID is not defined');
       return;
     }
   
     // Step 1: Fetch task info first
     this.meetingService.fetchTaskInfo(this.minAttrList.followUpTaskInfo.taskId).subscribe({
       next: (taskRes: any) => {
         const taskInfo = taskRes.body || {};
    
         this.taskInfo = taskInfo;
   
         // Step 2: Fetch notes for the meeting
         this.meetingService.fetchNotesByMeetingId(id, decryptKey).subscribe({
           next: (notes: any[]) => {
        
             this.toLinkingNotes = notes || [];
   
             // Step 3: Fetch agendas
             this.meetingService.fetchAgendaListByMeeting(id).subscribe({
               next: (agendas: any[]) => {
            
                 this.agendasinfoe = agendas || [];
                 
                 // Map notes to agendas
                 const agendasWithNotes = this.agendasinfoe.map((agenda: { agendaId: any; }) => ({
                   ...agenda,
                   notes: this.toLinkingNotes.filter((note: { agendaId: any; }) => note.agendaId === agenda.agendaId)
                 }));
            
                 // Open dialog
                 // this.dialog.open(LinkTasktonoteDialogComponent, {
                 //   data: {
                 //     meetingRes: this.toLinkingNotes,
                 //     agendas: this.agendasinfoe,
                 //     agendasWithNotes,
                 //     taskRes: this.taskInfo,
                 //     linkedNoteIds: Array.isArray(taskInfo.linkedNoteIds)
                 //       ? taskInfo.linkedNoteIds
                 //       : []
                 //   },
                 //   panelClass: ['animate__animated', 'animate__slideInLeft'],
                 //   disableClose: false,
                 //   position: { left: '0%' },
                 //   maxWidth: '100vw',
                 //   maxHeight: '100vh',
                 //   width: '50%',
                 //   height: '100vh',
                 //   autoFocus: false
                 // });
                this.dialog.open(LinkNotetotaskDialogComponent, {
                            data: {
                              meetingRes: this.toLinkingNotes,
                              agendas: this.agendasinfoe,
                              agendasWithNotes,
                              type:"TASK",
                              meetingTitle:this.meetingResponse.meetingTitle,
                              noteRes: this.taskInfo,
                              FollowupTask:this.minAttrList.isFollowUpFlag,
                              linkedNoteIds: Array.isArray(this.taskInfo.linkedTaskIds)
                                ? this.taskInfo.linkedTaskIds
                                : []
                            },
                            panelClass: ['animate__animated', 'animate__slideInLeft'],
                            disableClose: false,
                            position: { left: '0%' },
                            maxWidth: '100vw',
                            maxHeight: '100vh',
                            width: '50%',
                            height: '100vh',
                            autoFocus: false
                          });
                        },
                        error: (err: any) => console.error('Error fetching agendas:', err)
                      });
                    },
                    error: (err: any) => console.error('Error fetching task:', err)
                  });
                },
                error: (err: any) => console.error('Error fetching notes:', err)
              });
                }

                // ===== Quill.js Integration for Followup Task =====
                onQuillEditorReady(quill: Quill) {
                  try {
                    this.quillInst = quill;
                    
                    // Register with shared toolbar
                    try {
                      const selectorId = 'quill-shared-toolbar';
                      quillSharedToolbar.registerEditor(quill, selectorId);
                    } catch {}

                    const rootEl = quill.root as HTMLElement;
                    const taskIdVal = this.minAttrList.followUpTaskInfo.taskId;

                    // Ensure legacy attributes
                    const ensureLegacyAttrs = () => {
                      try {
                        rootEl.id = 'agMinId' + taskIdVal;
                        rootEl.classList.add('agChildTask','minComCls');
                        rootEl.setAttribute('minId', String(taskIdVal));
                        rootEl.setAttribute('minid', String(taskIdVal));
                        rootEl.setAttribute('taskId', String(taskIdVal));
                        rootEl.setAttribute('agId', String(this.minAttrList.followUpTaskInfo.agendaId));
                        rootEl.setAttribute('agid', String(this.minAttrList.followUpTaskInfo.agendaId));
                        rootEl.setAttribute('parentAgId', String(this.minAttrList.agendaId));
                        rootEl.setAttribute('entityType', this.minAttrList?.followUpTaskInfo?.entityType || 'AI');
                        rootEl.setAttribute('isFollowUpFlag', this.minAttrList.isFollowUpFlag || 'N');
                        rootEl.setAttribute('curAgendaId', String(this.minAttrList.agendaId));
                        rootEl.setAttribute('curNoteId', String(this.minAttrList.noteId));
                        rootEl.setAttribute('curMeetingId', String(this.minAttrList.meetingId));
                        rootEl.setAttribute('meetingId', String(this.minAttrList.followUpTaskInfo.meetingId));
                        rootEl.setAttribute('prevAgendaId', String(this.minAttrList.followUpTaskInfo.agendaId));
                        rootEl.setAttribute('prevMeetingId', String(this.minAttrList.followUpTaskInfo.meetingId));
                        rootEl.setAttribute('prevMinuteId', String(taskIdVal));
                      } catch {}
                    };
                    ensureLegacyAttrs();

                    // Extract existing owner IDs from atwho-inserted spans in content
                    try {
                      const html = rootEl.innerHTML || '';
                      const temp = document.createElement('div');
                      temp.innerHTML = html;
                      const mentionSpans = temp.querySelectorAll('[class*="atwho-inserted"]');
                      const existingIds = new Set<string>();
                      
                      mentionSpans.forEach((span) => {
                        const userId = span.getAttribute('fkuserid') || span.getAttribute('id') || '';
                        if (userId) existingIds.add(userId);
                      });
                      
                      if (existingIds.size > 0) {
                        const idsString = Array.from(existingIds).join(',') + ',';
                        rootEl.setAttribute('existingownerids', idsString);
                      }
                    } catch (err) {
                      console.error('[followup-task] Error extracting existing owner IDs:', err);
                    }

                    // Guard blur-save while clicking toolbar
                    const selectorId = 'quill-shared-toolbar';
                    const shared = document.querySelector('#' + selectorId) as HTMLElement | null;
                    if (shared) {
                      shared.style.display = 'block';
                      shared.addEventListener('mousedown', () => { this.toolbarInteracting = true; }, true);
                      shared.addEventListener('mouseup', () => { setTimeout(() => this.toolbarInteracting = false, 0); }, true);
                      shared.addEventListener('click', () => { setTimeout(() => this.toolbarInteracting = false, 0); }, true);
                    }

                    // Outside click handler
                    let outsideClickHandler: ((ev: MouseEvent) => void) | null = null;
                    outsideClickHandler = (ev: MouseEvent) => {
                      if (!this.isActiveEditor || !this.hasUserInteracted) return;
                      
                      const t = ev.target as Node;
                      const insideEditor = rootEl.contains(t);
                      const insideToolbar = shared ? shared.contains(t) : false;
                      
                      if (!insideEditor && !insideToolbar) {
                        this.isActiveEditor = false;
                        this.onQuillBlur();
                      }
                    };
                    document.addEventListener('mousedown', outsideClickHandler, true);

                    // Click -> mark as interacted
                    rootEl.addEventListener('click', () => {
                      ensureLegacyAttrs();
                      this.isActiveEditor = true;
                      this.hasUserInteracted = true;
                    });

                    // Mark active on direct interactions
                    rootEl.addEventListener('mousedown', () => { 
                      this.isActiveEditor = true; 
                      this.hasUserInteracted = true; 
                    }, true);
                    
                    rootEl.addEventListener('focusin', () => { 
                      this.isActiveEditor = true; 
                      this.hasUserInteracted = true; 
                    }, true);

                    // Keyboard helpers for slash shortcuts
                    rootEl.addEventListener('keydown', (ev: KeyboardEvent) => {
                      if (!this.hasUserInteracted) this.hasUserInteracted = true;
                      const keyCode = (ev as any).keyCode || ev.which;

                      // Handle Enter for slash shortcuts: delete token, handle /date inline, delegate others, then blur-save
                      if (keyCode === 13) {
                        try {
                          const sel = quill.getSelection();
                          if (!sel) return;
                          const caret = sel.index;
                          const MAX = 48;
                          const start = Math.max(0, caret - MAX);
                          // Window and ignore trailing whitespace
                          let seg = quill.getText(start, caret - start);
                          const trailing = seg.match(/[\s\u00a0]+$/);
                          const strip = trailing ? trailing[0].length : 0;
                          const effEnd = caret - strip;
                          const effLen = effEnd - start;
                          if (effLen <= 0) return;
                          seg = quill.getText(start, effLen);

                          const slash = seg.lastIndexOf('/');
                          if (slash < 0) return;
                          let token = '/';
                          for (let i = slash + 1; i < seg.length && token.length <= 5; i++) {
                            const ch = seg[i];
                            if (!/[a-z]/i.test(ch)) break;
                            token += ch;
                          }
                          const valid = /^(\/nn|\/dd|\/tt|\/ag|\/date|\/dur|\/sg|\/agl|\/sgl|\/ddl|\/ttl|\/nnl)$/i;
                          if (!valid.test(token)) return;

                          // Delete only the token from Quill content
                          const delLen = token.length + strip;
                          quill.deleteText(effEnd - token.length, delLen, 'user');

                          const t = token.toLowerCase();
                          if (t === '/date') {
                            // Keep inline date behavior for follow-up tasks
                            try {
                              const duedate = this.utilService.curSysDate('M dd, yy');
                              const entityCode = (this.minAttrList?.followUpTaskInfo?.entityType as string) || 'AI';
                              let aiTimeZone = '';
                              try { if ((this.globals as any).showTimezone_Date === 'Y') { aiTimeZone = "<span class='taskTimezoneCls'> " + (this.globals as any).vShortTimeZone + "</span>"; } } catch {}
                              const range = quill.getSelection(true) || { index: quill.getLength(), length: 0 };
                              (quill as any).insertEmbed(range.index, 'date', { code: entityCode, text: `${duedate}${aiTimeZone}` }, 'user');
                              (quill as any).insertText(range.index + 1, ' ', 'user');
                              (quill as any).setSelection(range.index + 2, 0, 'user');
                              try { this.commonAgService.noteDecisionDatepicker(quill); } catch {}
                            } catch {}
                          } else {
                            // Delegate others to legacy service
                            ensureLegacyAttrs();
                            try {
                              if (t === '/ag') {
                                try { rootEl.removeAttribute('parentAgId'); } catch {}
                              } else if (t === '/sg') {
                                try { rootEl.setAttribute('parentAgId', String(this.minAttrList.followUpTaskInfo.agendaId)); } catch {}
                              }
                            } catch {}
                            const syntheticEvent: any = {
                              target: rootEl,
                              currentTarget: rootEl,
                              preventDefault: () => {},
                              cancel: () => {}
                            };
                            this.freeFormAgenda.trackAgendaEventOnClick(syntheticEvent, t);
                          }

                          // Force a blur-save so content updates immediately
                          try { setTimeout(() => this.onQuillBlur(), 0); } catch {}

                          ev.preventDefault(); ev.stopPropagation();
                          return;
                        } catch {}
                      }
                    });

                    // Upload adapter
                    try {
                      const cfg = (this.commonAgService as any)['agoraConfig']?.getConfig();
                      if (cfg) {
                        setupQuillUploadAdapter(
                          quill,
                          cfg.apiBaseUrl,
                          cfg.endpoints.attachment,
                          this.meetingResponse?.meetingId,
                          this.minAttrList.followUpTaskInfo.agendaId,
                          (_url: string) => { try { setTimeout(() => this.onQuillBlur(), 0); } catch {} }
                        );
                      }
                    } catch {}

                    // 👇 @ Mention keyboard handlers
                    // Arrow Down
                    quill.keyboard.addBinding(
                      { key: 40 },
                      (range: any, context: any) => {
                        if (!this.showDropdown) return true;
                        if (!this.mentionList.length) return true;

                        this.activeIndex = (this.activeIndex + 1) % this.mentionList.length;
                        this.cdr.markForCheck();
                        return false;
                      }
                    );

                    // Arrow Up
                    quill.keyboard.addBinding(
                      { key: 38 },
                      (range: any, context: any) => {
                        if (!this.showDropdown) return true;
                        if (!this.mentionList.length) return true;

                        this.activeIndex = (this.activeIndex - 1 + this.mentionList.length) % this.mentionList.length;
                        this.cdr.markForCheck();
                        return false;
                      }
                    );

                    // ============= DIRECT KEYDOWN LISTENER FOR ENTER KEY =============
                    // This is BEFORE Quill's keyboard binding to intercept the event early
                    
                    rootEl.addEventListener('keydown', (event: KeyboardEvent) => {
                      const isEnter = event.keyCode === 13 || event.key === 'Enter';
                      const isDropdownOpen = this.showDropdown && this.mentionList && this.mentionList.length > 0;
                      
                      if (!isEnter) return; // Not Enter key, let it through
                      
                      if (!isDropdownOpen) {
                        return; // Dropdown closed, allow normal Enter (newline)
                      }

                      // DROPDOWN IS OPEN - BLOCK ENTER AND SELECT ITEM
                      event.preventDefault(); // STOP THE EVENT COMPLETELY
                      event.stopPropagation();
                      
                      const user = this.mentionList[this.activeIndex];
                      if (user) {
                        this.insertAssignedUser(user, quill);
                        this.cdr.markForCheck();
                      } else if (this.mentionList.length > 0) {
                        this.insertAssignedUser(this.mentionList[0], quill);
                        this.cdr.markForCheck();
                      }
                    }, true); // Capture phase - runs BEFORE Quill's handlers

                    // Text change listener for @ mention
                    quill.on('text-change', async () => {
                      const range = quill.getSelection();
                      if (!range) return;

                      const textBefore = quill.getText(0, range.index);
                      const match = textBefore.match(/@([\w\s]*)$/);

                      if (match) {
                        const queryText = match[1] || '';
                        this.mentionIndex = range.index - match[0].length;

                        const users = await this.getMentionUsers(rootEl);

                        // ALWAYS show full list when only @
                        if (queryText.length === 0) {
                          this.mentionList = users;
                        } else {
                          this.mentionList = users.filter((u: any) =>
                            u.name.toLowerCase().includes(queryText.toLowerCase())
                          );
                        }

                        this.showDropdown = this.mentionList.length > 0;

                        if (this.showDropdown) {
                          this.activeIndex = 0;

                          // 👇 Calculate responsive dropdown position from @ position (mentionIndex), not cursor
                          try {
                            // Use mentionIndex (where @ is) instead of range.index (current cursor)
                            const bounds = quill.getBounds(this.mentionIndex) || { top: 0, left: 0, height: 0 };
                            const dropdownHeight = 220; // Match CSS max-height
                            const viewportHeight = window.innerHeight;
                            const spaceBelow = viewportHeight - (bounds.top + bounds.height);
                            const DROPDOWN_OFFSET = 25; // Offset to show @ and search text
                            const HORIZONTAL_OFFSET = 10; // Slight horizontal adjustment
                            
                            let top: number;
                            if (spaceBelow > dropdownHeight) {
                              // Enough space below - position dropdown below the @ with offset
                              top = bounds.top + bounds.height + DROPDOWN_OFFSET;
                            } else {
                              // Not enough space below - position dropdown above the @ with offset
                              top = bounds.top - dropdownHeight - DROPDOWN_OFFSET;
                            }
                            
                            this.dropdownPosition = {
                              top: Math.max(0, top),
                              left: Math.max(0, bounds.left + HORIZONTAL_OFFSET)
                            };
                            
                            this.cdr.markForCheck();
                          } catch (err) {
                            console.warn('Error calculating dropdown position:', err);
                            this.dropdownPosition = { top: 0, left: 0 };
                          }
                        }
                      } else {
                        this.showDropdown = false;
                        this.mentionList = [];
                        this.activeIndex = 0;
                        
                        // Trigger change detection to hide dropdown
                        this.cdr.markForCheck();
                      }
                    });
                  } catch {}
                }

                onQuillBlur() {
                  try {
                    if (!this.hasUserInteracted) return;
                    if (this.toolbarInteracting || this.blurSavingGuard) return;
                    
                    // Close mention dropdown on blur
                    this.showDropdown = false;
                    this.mentionList = [];
                    this.activeIndex = 0;
                    this.cdr.markForCheck();
                    
                    this.blurSavingGuard = true;
                    const taskIdVal = this.minAttrList.followUpTaskInfo.taskId;
                    const host = document.getElementById('agMinId' + taskIdVal) as HTMLElement | null;
                    const html = host ? host.innerHTML : '';
                    const legacy = document.createElement('div');
                    legacy.id = 'agMinId' + taskIdVal;
                    legacy.classList.add('agChildTask','minComCls');
                    legacy.setAttribute('minId', String(taskIdVal));
                    legacy.setAttribute('minid', String(taskIdVal));
                    legacy.setAttribute('taskId', String(taskIdVal));
                    legacy.setAttribute('agId', String(this.minAttrList.followUpTaskInfo.agendaId));
                    legacy.setAttribute('agid', String(this.minAttrList.followUpTaskInfo.agendaId));
                    legacy.setAttribute('parentAgId', String(this.minAttrList.agendaId));
                    legacy.setAttribute('entityType', this.minAttrList?.followUpTaskInfo?.entityType || 'AI');
                    legacy.setAttribute('isFollowUpFlag', this.minAttrList.isFollowUpFlag || 'N');
                    legacy.setAttribute('curAgendaId', String(this.minAttrList.agendaId));
                    legacy.setAttribute('curNoteId', String(this.minAttrList.noteId));
                    legacy.setAttribute('curMeetingId', String(this.minAttrList.meetingId));
                    legacy.setAttribute('meetingId', String(this.minAttrList.followUpTaskInfo.meetingId));
                    legacy.setAttribute('prevAgendaId', String(this.minAttrList.followUpTaskInfo.agendaId));
                    legacy.setAttribute('prevMeetingId', String(this.minAttrList.followUpTaskInfo.meetingId));
                    legacy.setAttribute('prevMinuteId', String(taskIdVal));
                    legacy.innerHTML = html || '';
                    const fakeEvent: any = { target: legacy, currentTarget: legacy, preventDefault: () => {}, stopPropagation: () => {} };
                    this.commonMinService.triggerSaveMinutes(legacy, fakeEvent);
                  } catch {}
                  finally { setTimeout(() => { this.blurSavingGuard = false; }, 250); }
                }

                onQuillFocus() {
                  try { 
                    this.isActiveEditor = true; 
                    this.hasUserInteracted = true; 
                  } catch {}
                }

                onQuillSelectionChanged(e: any) {
                  // DO NOT use selection-change for blur - handled by outside click
                }

                insertAssignedUser(user: any, quill: Quill) {
                  try {
                    const userId = user.userId || user.id || '';
                    const name = (user.name || '').trim();
                    
                    if (!userId || !name) return;
                    
                    // Get current selection range
                    const range = quill.getSelection(true) || { index: quill.getLength(), length: 0 };
                    
                    // Get the root element and check for existing owner label BEFORE deleting
                    const rootEl = quill.root as HTMLElement;
                    const html = rootEl.innerHTML || '';
                    
                    // Check if owner label already exists (look for assignCls)
                    const labelExists = html.includes('assignCls');

                    // Use mentionIndex which is set in text-change event - this is the position of @
                    let index = range.index;
                    
                    // Remove @query text (replace @ with mention) - ONLY delete from @ to current position
                    if (this.mentionIndex != null) {
                      quill.deleteText(
                        this.mentionIndex,
                        index - this.mentionIndex
                      );
                      index = this.mentionIndex;
                    }

                    let finalInsertionIndex = index;

                    // If label doesn't exist, ADD IT at the mention position (where @ was)
                    if (!labelExists) {                      
                      // Insert owner label blot at the @ position
                      // Using insertEmbed instead of dangerouslyPasteHTML for proper position tracking
                      (quill as any).insertEmbed(index, 'taskownerlabel', {});
                      
                      // Add a space after the label
                      quill.insertText(index + 1, ' ');
                      
                      // Mention insertion index = after label + space (consistent with instant-meeting-task)
                      finalInsertionIndex = index + 2;
                    } else {
                      finalInsertionIndex = index;
                    }

                    // Insert the user mention (with comma if not the first mention)
                    const updatedHtml = rootEl.innerHTML || '';
                    const mentionSpansExist = updatedHtml.includes('class="atwho-inserted"');
                    
                    // For subsequent users, prepend comma to the name
                    const displayName = mentionSpansExist ? `, ${name}` : name;
                    const value = {
                      userId: userId,
                      name: displayName,
                      email: user.email || ''
                    };
                    
                    // Insert the mention blot (replaces the @ symbol)
                    (quill as any).insertEmbed(finalInsertionIndex, 'atwhomention', value);
                    
                    // Add space after mention
                    quill.insertText(finalInsertionIndex + 1, ' ');
                    
                    // Move cursor to after the mention and space
                    quill.setSelection(finalInsertionIndex + 2, 0, 'user');

                    // Update existingOwnerIds
                    try {
                      const root = quill.root as HTMLElement;
                      const prev = root.getAttribute('existingownerids') || root.getAttribute('existingOwnerIds') || '';
                      const existingIds = prev.split(',').filter(Boolean);
                      if (!existingIds.includes(userId)) {
                        root.setAttribute('existingownerids', (prev + userId + ',').replace(/,,+/g, ','));
                      }
                    } catch {}
                    
                  } catch (err) {
                    console.error('[followup-task] Error inserting assigned user:', err);
                  }
                }

                onMentionItemClick(user: any, event: MouseEvent) {
                  if (event) {
                    event.preventDefault();
                    event.stopPropagation();
                  }

                  if (this.quillInst) {
                    this.insertAssignedUser(user, this.quillInst);
                    this.showDropdown = false;
                    this.mentionList = [];
                    this.activeIndex = 0;
                    
                    // Trigger change detection for OnPush strategy
                    this.cdr.markForCheck();
                  }
                }

                onReadOnlyQuillEditorReady(quill: Quill) {
                  try {
                    quill.enable(false);
                  } catch {}
                }

                getMentionUsers(elem: HTMLElement) {
                  return this.attendeeService.fetchUserListSource("").then((result: any) => {
              
                    // 1 Read attribute safely (native DOM)
                    const existingOwnerIdsAttr =
                      elem.getAttribute('existingownerids') || '';
              
                    // 2 Convert "197,198," → ["197","198"]
                    const existingOwnerIds = new Set(
                      existingOwnerIdsAttr
                        .split(',')
                        .map(id => id.trim())
                        .filter(id => id) // remove empty values
                    );
                        
                    // 3 Filter users
                    return result
                      .filter((u: any) => !existingOwnerIds.has(u.userId.toString()))
                      .map((u: any) => {
                        const name = u.userLastname
                          ? `${u.userFirstname} ${u.userLastname}`
                          : u.userFirstname;
              
                        // CKEditor 5 requires the mention id to include the marker (e.g. "@Barney").
                        // Provide numeric userId separately for our custom downcast rendering.
                        const label = `@${name}`;
                        return {
                          id: label,           // must include marker for CKEditor mention
                          text: name + ', ',   // insert name followed by comma+space
                          name: name,
                          email: u.userEmail,
                          userId: u.userId.toString()
                        };
                      });
                  });
                }
  
  insertOwnerLabelBeforeFirstMention(editor: any) {
    editor.model.change((writer: any) => {
      const root = editor.model.document.getRoot();
  
      for (const block of root.getChildren()) {
        if (!block.is('element', 'paragraph')) continue;
  
        for (const child of block.getChildren()) {
          //first mention text node
          if (child.is('$text') && child.hasAttribute('mention')) {
            const insertPos = writer.createPositionBefore(child);
  
            const viewFragment = editor.data.processor.toView(
              '<span class="assignCls">Owner(s):&nbsp;</span>'
            );
  
            const modelFragment = editor.data.toModel(viewFragment);
  
            editor.model.insertContent(modelFragment, insertPos);
            return; 
          }
        }
      }
    });
  }
  
}
